import React from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { signOut } from "../../utils/firebase";

const Footer = (props) => {
  function handleSignout() {
    return signOut();
  }
  if (props.signedIn) {
    return (
      <div className="footer" style={{ marginBottom: "2em" }}>
        <button className="btn btn-info" onClick={() => handleSignout()}>
          Logout
        </button>
      </div>
    );
  } else {
    return <div className="footer"></div>;
  }
};

Footer.propTypes = {
  signedIn: PropTypes.bool,
};

const routerFooter = withRouter(Footer);
export default routerFooter;
